var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandGoogleYouTubeStyleBrand = function SvgBrandGoogleYouTubeStyleBrand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M23.47 6.632a3.02 3.02 0 0 0-2.124-2.124C19.483 4 11.988 4 11.988 4s-7.496.015-9.359.523A3.02 3.02 0 0 0 .505 6.648c-.563 3.309-.782 8.351.016 11.528A3.02 3.02 0 0 0 2.645 20.3c1.862.508 9.358.508 9.358.508s7.496 0 9.358-.508a3.02 3.02 0 0 0 2.124-2.124c.595-3.314.778-8.353-.015-11.544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.602 16.006 6.218-3.602-6.218-3.602z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandGoogleYouTubeStyleBrand);
export { ForwardRef as ReactComponent };